import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=38bd07cd&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=38bd07cd&prod&lang=scss&scoped=true"
import style1 from "./footer.vue?vue&type=style&index=1&id=38bd07cd&prod&lang=scss&scoped=true"
import style2 from "./footer.vue?vue&type=style&index=2&id=38bd07cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd07cd",
  null
  
)

export default component.exports